<ng-container *ngIf="false">
  <mat-label class="input-label text-nowrap attch pointer mb-0 " *ngIf="label_visible &&label"
    style="display: block;padding: 0;margin-top: -4px;font-weight:500;font-size:var(--font-13)">
    {{label |translate}}
    <span *ngIf="multiple" class="float-right pointer link" (click)="fileInput.click()"> Attach a Document </span>
    <span style="color:red" *ngIf="required">*</span>
  </mat-label>

  <div class="attachment-container" [ngClass]="{'design-pattern-2':design_pattern==2}" [ngStyle]="style" [id]="id">
    <ng-container *ngIf="true">
      <div class="input-group  hide-dropdown-arrow " *ngIf="design_pattern==1 || !design_pattern">
        <div class="form-control dropdown pointer dropdown-toggle  " (mouseenter)="calculatePosition()" *ngIf="result ">
          <span class='w-100' [title]="label + ' (' +result.length  + ')' " style="display: block;"
            (click)="fileInput.click()">
            {{label}} <span style="color:red" *ngIf="required && !label_visible">*</span>
            ({{result.length}})
          </span>
          <div class="dropdown-content " style="right: 0!important" [ngStyle]="{'height':'auto'}"
            [style.width.px]="container_width" *ngIf="result && result.length">
            <a class="dropdown-item pointer" [title]="i['fileName'] ||
          i[this.save_filename]" *ngFor="let i of result;let index = index"
              [ngClass]="{'overflow-may':result.length>10 && index == result.length-1}">
              <span class="sam mr-2">{{i['fileName'] ||
                i[this.save_filename]}}</span>
              <span class="btn btn-sm js-btn-save ml-auto mx-1" (click)="view(i)">
                <i class="fa fa-eye"></i>
              </span>
              <span *ngIf="!disabled" class="btn  btn-sm js-btn-cancel ml-1" (click)="removeFile(i)">
                <i class="fa fa-times "></i>
              </span>


            </a>
          </div>
        </div>

        <!-- <ng-container *ngIf="result">
        <span class="form-control pointer" [title]="i[this.save_filename]" *ngFor="let i of result"
          (click)="fileInput.click()">{{i['fileName'] ||
          i[this.save_filename]}}</span>
      </ng-container> -->

        <!-- <input type="file" class="form-control" (click)="fileInput.click()" placeholder="Recipient's username"
        aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
        <div class="input-group-append pointer ">
          <span (click)="fileInput.click()" class="btn btn-sm js-btn-save ff" style="font-size: 12px;">
            <i class="fa fa-paperclip mr-1"></i>
          </span>
          <span (click)="parseAgain()" *ngIf="resume_parser && result && result.length"
            [title]="'Parse again' |translate" class="btn ml-1 btn-sm js-btn-save ff" style="font-size: 12px;">
            <i class="fa fa-refresh mr-1"></i>
          </span>
        </div>

        <!-- <ng-container *ngIf="result &&result.length">
        <div class="input-group-append" *ngFor="let i of result">
          <span class="input-group-text" id="basic-addon2">
            <a class="" style="line-height: 1;"
              [attr.href]="i[save_cdnpath] && i.content ? ((i.content) | SafeFilePipe):( i && i[save_cdnpath]&& i[save_cdnpath]!='' ?storage_url+ i[save_cdnpath] : '')"
              [attr.download]="i[save_filename]" matTooltip="Download" target='_self'>
              <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </span>
        </div>
      </ng-container> -->

      </div>
      <div class="input-group  hide-dropdown-arrow " *ngIf="design_pattern==2 ">
        <div class="form-control dropdown pointer dropdown-toggle  " (mouseenter)="calculatePosition()" *ngIf="result ">
          <span class='w-100' [title]="label + ' (' +result.length  + ')' " style="display: block;"
            (click)="fileInput.click()">
            {{label}} <span style="color:red" *ngIf="required && !label_visible">*</span>

            ({{result.length}})
          </span>
          <div class="dropdown-content " style="right: 0!important;top:25px!important" [ngStyle]="{'height':'auto'}"
            [style.width.px]="container_width" *ngIf="result && result.length">
            <a class="dropdown-item pointer" [title]="i['fileName'] ||
          i[this.save_filename]" *ngFor="let i of result;let index = index"
              [ngClass]="{'overflow-may':result.length>10 && index == result.length-1}">
              <span class="sam mr-2">{{i['fileName'] ||
                i[this.save_filename]}}</span>
              <span class="btn btn-sm js-btn-save ml-auto mx-1" style="line-height: 1 !important;" (click)="view(i)">
                <i class="fa fa-eye"></i>
              </span>
              <span *ngIf="!disabled" class="btn  btn-sm js-btn-cancel ml-1" style="line-height: 1 !important;"
                (click)="removeFile(i)">
                <i class="fa fa-times "></i>
              </span>


            </a>
          </div>
        </div>

        <!-- <ng-container *ngIf="result">
        <span class="form-control pointer" [title]="i[this.save_filename]" *ngFor="let i of result"
          (click)="fileInput.click()">{{i['fileName'] ||
          i[this.save_filename]}}</span>
      </ng-container> -->

        <!-- <input type="file" class="form-control" (click)="fileInput.click()" placeholder="Recipient's username"
        aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
        <div class="input-group-append pointer ">
          <span (click)="fileInput.click()" class="btn btn-sm btn-default m-0 ff"
            style="font-size: 12px; border: 2px solid;">
            <i class="fa fa-paperclip mr-1"></i>
          </span>
          <span (click)="parseAgain()" *ngIf="resume_parser && result && result.length"
            [title]="'Parse again' |translate" class="btn btn-sm btn-default ff"
            style="font-size: 12px; border: 2px solid">
            <i class="fa fa-refresh mr-1"></i>
          </span>
        </div>

        <!-- <ng-container *ngIf="result &&result.length">
        <div class="input-group-append" *ngFor="let i of result">
          <span class="input-group-text" id="basic-addon2">
            <a class="" style="line-height: 1;"
              [attr.href]="i[save_cdnpath] && i.content ? ((i.content) | SafeFilePipe):( i && i[save_cdnpath]&& i[save_cdnpath]!='' ?storage_url+ i[save_cdnpath] : '')"
              [attr.download]="i[save_filename]" matTooltip="Download" target='_self'>
              <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </span>
        </div>
      </ng-container> -->
        <!-- ref=INT& -->

      </div>
      <div class="input-group  hide-dropdown-arrow " *ngIf="design_pattern==3">
        <div class="resume-upload">
          <div *ngIf="result && result.length ==0  || !result" class="w-100">
            <h6 class="file-upload-heading line-1 mb-1" [title]="'Your resume is required'|translate">Your resume is
              required
            </h6>
            <p [title]="'Please upload your Resume to proceed further '|translate"
              class="file-upload-description line-2 mb-1">
              Please upload your Resume to proceed further</p>
          </div>
          <div *ngIf="result && result.length" class="w-100">
            <h6 class="file-upload-heading line-1" [title]="result[0][save_filename] || result[0].file_title"
              [title]="result[0][save_filename] || result[0].file_title">
              <span>
                {{result[0][save_filename] || result[0].file_title}}
              </span>
              <i class="ml-auto date-control">
                <!-- <ng-container *ngIf="result[0].size">
                Size: {{result[0].size *0.000125}} KB ,
              </ng-container> -->
                <span *ngIf="result[0].last_modifield_date" [title]="'Last modified date'">
                  {{result[0].last_modifield_date |
                  UtcToLocalTime | date : 'dd-MMM-yyyy h:mm a'}}
                </span>
              </i>
            </h6>
          </div>
          <div class="w-100 text-right">
            <!-- <span (click)="fileInput.click()" class="btn btn-sm btn-default m-0 ff"
            style="font-size: 12px; border: 2px solid;">
            <i class="fa fa-paperclip mr-1"></i>
          </span> -->
            <!-- <span class=" ml-3 mr-1 btn btn-sm js-btn-save" type="button" *ngIf="result &&
          result.length" (click)="view(result[0])">View</span> -->
            <span class=" mx-1 ml-e link" (click)="view(result[0])" *ngIf="result &&
          result.length" type="button">View Resume</span>
            <span class=" ml-e mx-1 link" (click)="fileInput.click()" type="button">{{result &&
              result.length?'Change':'Upload'}} Resume</span>
          </div>
        </div>
      </div>

      <!-- <div id="FileUpload">
      <div class="wrapper">
        <div class="uploaded uploaded--one">
          <i class="fa fa-file-pdf"></i>
          <div class="file">
            <div class="file__name" (click)="fileInput.click()">
              <p *ngIf="result && result.length==0">{{ label}}</p>
              <p *ngIf="!result">{{ label}}</p>
              <i class="fa fa-times"></i>
            </div>
          </div>
        </div>
      </div>
    </div> -->
      <!-- <span (click)="fileInput.click()" *ngIf="result && result.length==0" style="font-size: var(--font-13);"
      class="link pointer mr-2">Attach here:</span>
    <label *ngFor="let item of result ;let i =index" style="display: block;">
      <span class="file-title" style="width: 100%;" [ngClass]="{'mb-0':i==(result.length-1)}">
        <span style="max-width: 22% !important; width : 22%; display: inline-flex;overflow:hidden" class="link mr-2"
          (click)="fileInput.click()">Attached:</span>
        <span [ngClass]="{'link':item[save_cdnpath]}"
          style="max-width: 65% !important; width : 65%; display: inline-flex;overflow:hidden"
          (click)="item[save_cdnpath]?view():''">
          {{item.fileName}}
        </span>
        <span class="pointer" style="display: inline-flex;
        max-width: 10% !important;
        align-items: center;
        justify-content: center;" (click)="removeFile(item)">
          <i style="font-size: 1rem;" class="fa fa-times-circle orange"></i>
        </span>
      </span>
    </label> -->
      <!-- <label *ngIf="result && result.length==0" style="max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    display:block;
    margin-bottom: .25rem">
      No attachment
    </label> -->
    </ng-container>
  </div>

  <input #fileInput [accept]="accept_file_type" [readonly]="disabled" [disabled]="disabled? true :false"
    (change)="fileInputChanged($event.target.files)" id="input-file{{id}}" type="file" [multiple]="multiple"
    style="display:none;">
</ng-container>

<mat-label class="input-label text-nowrap attch pointer mb-0 " *ngIf="label_visible &&label"
  style="display: block;padding: 0;margin-top: -4px;font-weight:500;font-size:13px">
  {{label |translate}}
  <span *ngIf="multiple" class="float-right pointer link" (click)="fileInput.click()"> Attach a Document </span>
  <span style="color:red" *ngIf="required">*</span>
</mat-label>

<div class="attachment-container" [ngClass]="{'design-pattern-2':design_pattern==2,'mb-0':cssClass =='mb-0'}"
  [ngStyle]="style" [id]="id">
  <ng-container *ngIf="true">
    <div class="input-group  hide-dropdown-arrow " *ngIf="design_pattern==1 || !design_pattern">
      <div class="form-control dropdown pointer dropdown-toggle  " (mouseenter)="calculatePosition()" *ngIf="result ">
        <span class='w-100' [title]="label + ' (' +result.length  + ')' " style="display: block;"
          (click)="fileInput.click()">
          {{label}} <span style="color:red" *ngIf="required && !label_visible">*</span>

          ({{result.length}})
        </span>
        <div class="dropdown-content " style="right: 0!important" [ngStyle]="{'height':'auto'}"
          [style.width.px]="container_width" *ngIf="result && result.length">
          <a class="dropdown-item pointer" [title]="i['fileName'] ||
          i[this.save_filename]" *ngFor="let i of result;let index = index"
            [ngClass]="{'overflow-may':result.length>10 && index == result.length-1}">
            <span class="sam mr-2">{{i['fileName'] ||
              i[this.save_filename] || i[save_cdnpath]}}</span>
            <span class="btn btn-sm js-btn-save ml-auto mx-1" (click)="view(i)">
              <i class="fa fa-eye"></i>
            </span>
            <span *ngIf="!disabled" class="btn  btn-sm js-btn-cancel ml-1" (click)="removeFile(i)">
              <i class="fa fa-times "></i>
            </span>


          </a>
        </div>
      </div>

      <!-- <ng-container *ngIf="result">
        <span class="form-control pointer" [title]="i[this.save_filename]" *ngFor="let i of result"
          (click)="fileInput.click()">{{i['fileName'] ||
          i[this.save_filename]}}</span>
      </ng-container> -->

      <!-- <input type="file" class="form-control" (click)="fileInput.click()" placeholder="Recipient's username"
        aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
      <div class="input-group-append pointer " style="z-index: 0;">
        <span (click)="fileInput.click()" class="btn btn-sm js-btn-save" style="font-size: 12px;">
          <i class="fa fa-paperclip mr-1"></i>
        </span>
        <span (click)="parseAgain()" *ngIf="resume_parser && result && result.length" [title]="'Parse again' |translate"
          class="btn ml-1 btn-sm js-btn-save" style="font-size: 12px;">
          <i class="fa fa-refresh mr-1"></i>
        </span>
      </div>

      <!-- <ng-container *ngIf="result &&result.length">
        <div class="input-group-append" *ngFor="let i of result">
          <span class="input-group-text" id="basic-addon2">
            <a class="" style="line-height: 1;"
              [attr.href]="i[save_cdnpath] && i.content ? ((i.content) | SafeFilePipe):( i && i[save_cdnpath]&& i[save_cdnpath]!='' ?storage_url+ i[save_cdnpath] : '')"
              [attr.download]="i[save_filename]" matTooltip="Download" target='_self'>
              <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </span>
        </div>
      </ng-container> -->

    </div>
    <div class="input-group  hide-dropdown-arrow " *ngIf="design_pattern==2 ">
      <div class="form-control dropdown pointer dropdown-toggle  " (mouseenter)="calculatePosition()" *ngIf="result ">
        <span class='w-100 line-1' [title]="label + ' (' +result.length  + ')' " (click)="fileInput.click()">
          {{label}} <span style="color:red" *ngIf="required && !label_visible">*</span>

          ({{result.length}})
        </span>
        <div class="dropdown-content " style="right: 0!important;top:25px!important" [ngStyle]="{'height':'auto'}"
          [style.width.px]="container_width" *ngIf="result && result.length">
          <a class="dropdown-item pointer" [title]="i['fileName'] ||
          i[this.save_filename]" *ngFor="let i of result;let index = index"
            [ngClass]="{'overflow-may':result.length>10 && index == result.length-1}">
            <span class="sam mr-2">{{i['fileName'] ||
              i[this.save_filename]}}</span>
            <span class="btn btn-sm js-btn-save ml-auto mx-1 " style="line-height: 1 !important;" (click)="view(i)">
              <i class="fa fa-eye"></i>
            </span>
            <span *ngIf="!disabled" class="btn  btn-sm js-btn-cancel ml-1" style="line-height: 1 !important;"
              (click)="removeFile(i)">
              <i class="fa fa-times "></i>
            </span>
          </a>
        </div>
      </div>

      <!-- <ng-container *ngIf="result">
        <span class="form-control pointer" [title]="i[this.save_filename]" *ngFor="let i of result"
          (click)="fileInput.click()">{{i['fileName'] ||
          i[this.save_filename]}}</span>
      </ng-container> -->

      <!-- <input type="file" class="form-control" (click)="fileInput.click()" placeholder="Recipient's username"
        aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
      <div class="input-group-append pointer ">
        <span (click)="fileInput.click()" class="btn btn-sm btn-default m-0"
          style="font-size: 12px; border: 2px solid;">
          <i class="fa fa-paperclip mr-1"></i>
        </span>
        <span (click)="parseAgain()" *ngIf="resume_parser && result && result.length" [title]="'Parse again' |translate"
          class="btn btn-sm btn-default" style="font-size: 12px; border: 2px solid">
          <i class="fa fa-refresh mr-1"></i>
        </span>
      </div>

      <!-- <ng-container *ngIf="result &&result.length">
        <div class="input-group-append" *ngFor="let i of result">
          <span class="input-group-text" id="basic-addon2">
            <a class="" style="line-height: 1;"
              [attr.href]="i[save_cdnpath] && i.content ? ((i.content) | SafeFilePipe):( i && i[save_cdnpath]&& i[save_cdnpath]!='' ?storage_url+ i[save_cdnpath] : '')"
              [attr.download]="i[save_filename]" matTooltip="Download" target='_self'>
              <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </span>
        </div>
      </ng-container> -->

    </div>
    <div class="input-group  hide-dropdown-arrow " *ngIf="design_pattern==3">
      <div class="resume-upload">
        <div *ngIf="false &&(result && result.length ==0  || !result)" class="w-100">
          <h6 class="file-upload-heading line-1 " [title]="'Your resume is required'|translate">
            <span [ngClass]="{'req':required}">
              Upload your resume to autofill the below details
            </span>
            <span class="ml-3">
              <span class=" mx-1 ml-e link" (click)="view(result[0])" *ngIf="result &&
              result.length" type="button">View Resume</span>
              <span class=" ml-e mx-1 link" (click)="fileInput.click()" type="button">{{result &&
                result.length?'Change Resume':'Upload'}} </span>
            </span>
          </h6>
          <!-- <p [title]="'Please upload your Resume to proceed further '|translate"
            class="file-upload-description line-2 mb-1">
            Please upload your Resume to proceed further</p> -->
        </div>
        <h6 class="file-upload-heading ">
          <span [ngClass]="{'req':required}">
            Upload your resume to autofill the below details
          </span>
          <span class="line-1 ml-1" style="font-weight:400 ;" *ngIf="result &&
            result.length">
            {{result[0][save_filename] || result[0].file_title}}
          </span>
          <span class="ml-3">
            <span class=" mx-1 ml-e link" (click)="view(result[0])" *ngIf="result &&
              result.length" type="button">View </span>
            <span class=" ml-e mx-1 link" (click)="fileInput.click()" type="button">{{result &&
              result.length?'Change':'Upload'}} </span>
          </span>
        </h6>
        <div class="w-100 text-right" *ngIf="false">
          <!-- <span (click)="fileInput.click()" class="btn btn-sm btn-default m-0 ff"
          style="font-size: 12px; border: 2px solid;">
          <i class="fa fa-paperclip mr-1"></i>
        </span> -->
          <!-- <span class=" ml-3 mr-1 btn btn-sm js-btn-save" type="button" *ngIf="result &&
        result.length" (click)="view(result[0])">View</span> -->
          <span class=" mx-1 ml-e link" (click)="view(result[0])" *ngIf="result &&
        result.length" type="button">View </span>
          <span class=" ml-e mx-1 link" (click)="fileInput.click()" type="button">{{result &&
            result.length?'Change':'Upload'}} </span>
        </div>
      </div>
    </div>

    <a class="link sample" *ngIf="sample_download_ref" (click)="downloadFile(sample_download_ref)"
      [title]="sample_download_ref_label">
      {{sample_download_ref.fileName}}
    </a>
    <a class="link sample"
      *ngIf="UIValidationObjStruct && UIValidationObjStruct.instructionAttachment && UIValidationObjStruct.instructionAttachment.value && !(UIValidationObjStruct.downloadMsg) "
      (click)="downloadInstructions(UIValidationObjStruct.instructionAttachment.value,UIValidationObjStruct)" [title]="UIValidationObjStruct.instructionText && UIValidationObjStruct.instructionText.value ?
      UIValidationObjStruct.instructionText.value : 'Instruction'">
      {{UIValidationObjStruct.instructionText && UIValidationObjStruct.instructionText.value ?
      UIValidationObjStruct.instructionText.value : 'Instruction'}}
      <ng-container *ngIf="UIValidationObjStruct  && (UIValidationObjStruct.successMsg) ">
        <a class="sample text-success font-weight-bold d-inline-block">
          (
          <i class="fa fa-check-circle  mr-1 "></i>
          {{UIValidationObjStruct.successMsg}}
          )
        </a>
      </ng-container>

    </a>

    <a class="sample orange font-weight-bold" *ngIf="UIValidationObjStruct  && (UIValidationObjStruct.downloadMsg) ">
      <i class="fa fa-spinner fa-spin mr-1 "></i>
      {{UIValidationObjStruct.downloadMsg}}
    </a>
  </ng-container>
</div>

<input #fileInput [accept]="accept_file_type" [readonly]="disabled" [disabled]="disabled? true :false"
  (change)="fileInputChanged($event.target.files)" id="input-file{{id}}" type="file" [multiple]="multiple"
  style="display:none;">